<script>
const models = window.models

import { selection, activeStep } from './lib.js';
</script>
<h2 class="byo-heading -interior">Choose Your Model</h2>
<p class="byo-text">Select from the available features we offer to see exactly how your dream Tiffin will look.</p>
<div class="byo-card">
        {#each models as model}
            <button class="byo-card__item {$selection == model ? 'selected': ''}" on:click="{() => { $selection = model; } }">
                <div class="byo-card__content js-model-preview-button">
                    <img src="{ model.image }" alt="{ model.title }">
                    <div class="model-preview__content js-height-set">
                        <h2 class="model-preview__content-heading">
                            { model.title }
                        </h2>
                        <div class="model-preview__content-desc -byo">
                            <div class="model-preview__content-rte">
                                {@html model.summary || ''}
                            </div>
                        </div>
                    </div>
                </div>
            </button>
    {/each}
</div>

<div class="continue-bar js-continue-bar {$selection.title ? '-active' : ''}">
    <button class="continue-bar__text button -forward js-forward" on:click="{() => { $activeStep = 1; window.scrollTo(0,0); }}">
        Next
    </button>
</div>

<style>
.model-preview__content-heading {
    font-size: 1rem !important;
    font-weight: 900;
    letter-spacing: .08rem;
    line-height: 1.2;
    margin-bottom: 1rem;
    text-align: center;
    text-transform: uppercase;
}

.selected .byo-card__content::after {
    font-family: icomoon;
    font-size: 1rem;
    font-weight: 400;
    line-height: 0;
    font-style: normal;
    content: "";
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #0b0b0b;
    border-radius: 50%;
    color: #fff;
    line-height: 2em;
    text-align: center;
}

</style>
